/**
 * 委托书模块的中文文案。
 * 按模块拆分语言包，避免单个语言文件随功能增长变成几千行。
 */
export default {
  sheetInfo: {
    requestType: "委托类型",
    requestNo: "委托书编号",
    requestDate: "委托日期",
    chargePlan: "商品企划",
    chargeProduction: "生产担当",
    chargeFabric: "面辅料采购",
    chargeTrim: "辅料采购",
    chargePattern: "版师",
    chargeCad: "版师",
    batch: "批次",
    batchHint: "生产批次：同一款号首次为 00，之后每加一次单递增 1",
  },

  stageProgress: '资料进度',
  nextStep: '下一步 / 负责',
  next: {
  cancelled: '已作废',
  fixAndResubmit: '按驳回意见修改 · 设计师',
  awaitApproval: '等待审批 · 设计室长',
  awaitTechpack: '待核对 Tech Pack · 生产管理',
  rolesFinishing: '各担当补录中 · 多角色',
  startDesign: '开始编制 · 设计师',
  designing: '设计编制中 · 设计师',
  },
  sheetSection: {
    "DESIGN": "设计",
    "MATERIAL": "面辅料",
    "PATTERN": "版型·尺寸",
    "QUANTITY": "订货数量",
    "TECHPACK": "Tech Pack",
    "QC": "QC 委托书",
    "ONLINE": "在线商品信息",
    "USP": "USP·设计意图"
  },

  sheetSectionState: {
    "done": "已完成",
    "partial": "进行中",
    "todo": "待录入",
    "planned": "规划中",
    "readonly": "只读查看"
  },

  sheetStage: {
    "TRIM_TECHNICAL_DONE": "辅料技术资料完成",
    "STEP_DONE": "本阶段完成",
    "DESIGNER_DONE": "设计录入完成",
    "PURCHASE_DONE": "面辅料采购完成",
    "PRODUCTION_REVIEWED": "生产检讨完成",
    "USAGE_ENTERED": "用量录入完成",
    "BASE_SIZE_DONE": "基准尺寸录入完成",
    "SIZE_SPEC_DONE": "尺寸偏差完成",
    "QUANTITY_CONFIRMED": "数量已确认"
  },


  chargeRole: {
    "DESIGN": "设计",
    "PLAN": "企划",
    "FABRIC": "面辅料采购",
    "TRIM": "辅料",
    "PRODUCTION": "生产",
    "PATTERN": "版型",
    "CAD": "版师",
    "TECHPACK": "技术包"
  },

  country: {
    "KR": "韩国",
    "CN": "中国",
    "HK": "香港",
    "TW": "台湾",
    "MY": "马来西亚"
  },

  techpack: {
    noSketch: "尚未上传设计图稿",
    fabrication: "面料信息 Fabrication",
    colorway: "颜色配色组、水洗 Color Way, Washing",
    orderQuantity: "订单数量 Order Quantity",
    total: "合计 Total",
    sizeSpec: "尺寸规格 SIZE SPEC(CM)",
    patternPart: "版型部位 Description",
    designMemo: "设计备注 Design Memo",
    styleCode: "款式代码",
    colorCode: "颜色代码",
    sizeCode: "尺码代码",
    skuCode: "单品代码-版本",
    all: "全部",
    colorNm: "颜色名称",
    sizeNm: "尺码名称",
    qty: "数量",
    moduleModelCd: "参考委托书编号",
    moduleStyleCd: "参考款号"
  },

  sheetTab: {
    "deviation": "尺寸偏差",
    "images": "图片资料",
    "main": "款式信息",
    "fabric": "面料与配色",
    "trimBom": "辅料 BOM",
    "cost": "用量与成本",
    "size": "版型·尺寸",
    "quantity": "订货数量",
    "techpack": "检讨·Tech Pack",
    "qc": "QC 委托书",
    "online": "在线商品信息",
    "usp": "USP·设计意图"
  },

  sheetStatus: {
    DRAFT: '草稿',
    PENDING: '审批中',
    APPROVED: '已批准',
    REJECTED: '已驳回',
    CANCELLED: '已作废',
  },



  sheet: {
    removeRowConfirm: '删除此行及其明细？',
    sectionUnavailable: '该部分暂未开放。',
  todoMissingPrice: '缺单价',
  todoMissingUsage: '缺用量',
  todoTechpackDone: 'Tech Pack 已确认',
  todoNotTransferred: '未传 SAP',
    allColors: "全色共通",
    pickColors: "选择适用颜色",
    materialAlias: "别名 Article",
    materialAliasPlaceholder: "旧面料别名",
    moduleModelCd: "参考委托书编号",
    moduleStyleCd: "参考款号",
    patternModuleNo: "版型模块号",
    patternModuleNoPlaceholder: "如 EEYW",
    realYardage: "实际用量",
    tolMinus: "−允许值",
    tolPlus: "+允许值",
    vendorNmPlaceholder: "Tech Pack 每页页眉显示",
    lCategory: "大分类",
    mCategory: "中分类",
    sCategory: "小分类",
    vendorNm: "供应商",
    composition: "成分",
    compositionPlaceholder: "如 C 100%",
    finishing: "后整理",
    stepTag: "第{n}步",
    materialsStepNote: "幅宽属于第 7 步、用量属于第 10 步，由对应担当填写；Tech Pack 的面料表要打印这两列，所以在这里就开放录入。",
    stdSizesNoSizes: "本单尚未收到颜色和尺码数据。请联系商品企划核对前序推送资料。",
    bomGroup: "分组",
    bomGroupTrim: "辅料",
    bomGroupThread: "缝纫线",
    trimImage: "辅料图",
    trimImageAfterSave: "保存后可上传",
    orderQuantity: "订单数量",
    orderQuantityHint: "按颜色和尺码查看前序环节确定的订货数量，无需再次确认。",
    orderQuantityEmpty: "尚未收到该款的订货数量。请联系商品企划核对前序推送资料。",
    quantityReadonly: "数量快照 · 只读",
    readonlyFromSap: "SAP 带回 · 只读",
    techPackTitle: "Tech Pack 预览",
    techPackHint: "核对技术包。选择“导出 PDF”后，在打印窗口中选择“另存为 PDF”。",
    exportPdf: "导出 PDF",
    shippingHint: "Shipping Instruction 的四个分区，对应 Tech Pack 第 7 页。",
    inProgressSuffix: " 中",
    techPackPreview: "TECH PACK 预览",
    techPackTodo: "TECH PACK 预览待开发",
    flatSketch: "设计图稿",
    designDraft: "设计稿",
    designDraftHint: "委托书的核心设计图。可上传 PDF（自动拆成图片）或多张图片。",
    flatSketchHint: "委托书的核心图。上传后可点击查看大图。",
    fgImage: "FG 资料",
    fgImageHint: "FG 资料支持图片、PDF 和 Illustrator（.ai）原件。",
    fgTypeError: "FG 资料支持图片、PDF 和 Illustrator（.ai）原件。",
    uploadFg: "上传 FG 资料",
    uploadHub: {
      tooLarge: "『{name}』超过 {mb}MB 上限",
    },
    detailImages: "详细图片",
    detailImagesHint: "款式细节、工艺参考等，可上传多张",
    trimImages: "辅料相关图片",
    trimImagesHint: "辅料图片、标签缝制方法、Shipping 信息",
    subMaterialImage: "辅料图片",
    labelSewing: "标签缝制方法",
    shipping: "Shipping 信息",
    patternSpecImage: "版型规格图",
    patternSpecImageHint: "版型/纸样的规格说明图",
    subMaterials: "辅料 BOM",
    subMaterialsHint: "辅料主行 + 按尺码的规格 + 按颜色的颜色名，点右侧「+」展开子项",
    subMaterialsEmpty: "暂无辅料 — 点「新增行」开始录入",
    subMaterialType: "辅料种类",
    subMaterialCd: "辅料代码",
    subMaterialContents: "辅料内容",
    subMaterialUsedPart: "使用部位",
    subMaterialSizes: "按尺码的规格",
    subMaterialColors: "按颜色的颜色名",
    sizeCd: "尺码",
    gauge: "规格",
    gaugeUnit: "规格单位",
    unitPrice: "单价",
    currency: "币种",
    colorNm: "颜色名",
    detail: "明细",
    stdSizes: "基准尺寸",
    stdSizesHint: "样品标准说明。一行一个样品部位。",
    stdSizesEmpty: "暂无基准尺寸 — 点「从主数据带入」或「新增行」开始",
    stdSizesLaterNote: "左右偏差与允许值在「尺寸偏差」环节补充，此处可先留空。",
    baseSizeIs: "基准尺码 {size}",
    fillFromMaster: "从主数据带入",
    fillDialogTitle: '从主数据导入样品部位',
    fillDialogHint: '共 1,030 个部位，按历史使用频度排序；输入代码或名称过滤后勾选（单次最多 100 行）。',
    fillSearchPlaceholder: '搜代码 / 名称',
    fillSelectAll: '全选当前筛选',
    fillClearAll: '清空',
    fillSelectedCount: '已选 {n} / 上限 {max}',
    fillAdded: '已添加 {n} 行',
    patternPart: "样品部位",
    patternPartNm: "部位名称",
    sizeValue: "尺寸",
    tolLeft: "左偏差",
    tolRight: "右偏差",
    measurement: "测量方法",
    attachAdd: "上传文件",
    attachReplaceImage: "替换图片",
    attachImageTypeError: "请选择 JPG、PNG、WEBP 或 GIF 图片。",
    attachImagesHint: "PNG / JPG / WEBP / GIF · ≤{mb} MB",
    attachReplace: "替换文件",
    attachUploading: "上传中…",
    attachUploaded: "已上传",
    attachLoadFailed: '未能读取文件',
    attachEmpty: "暂无文件",
    attachHint: "支持 PNG / JPG / WEBP / GIF / PDF，单个不超过 20MB",
    sourceAttachHint: "支持 PDF / PPT，单个不超过 {mb}MB",
    sourceTypeError: "设计原稿只收 PDF 与 PPT 文件",
    attachOpen: "点击打开",
    designSource: "设计原稿",
    designSourceHint: "设计师上传的整份 PDF / PPT 原件，留作版式识别与追溯，不进 Tech Pack。「导入设计稿」时会自动存进来。",
    attachTypeError: "不支持的文件类型，仅支持图片与 PDF",
    attachSizeError: "文件超过 {mb}MB 上限",
    attachDeleteConfirm: "确定删除这个附件吗？",
    changeLog: "修改履历",
    changeLogCount: "{n} 条",
    changeLogThisSection: "本阶段",
    changeLogAll: "全部",
    changeLogEmpty: "本阶段尚无修改记录。",
    changeLogTime: "时间",
    changeLogActor: "修改人",
    changeLogArea: "区域",
    changeLogFields: "修改的内容",
    changeLogSheetLevel: "整单",
    sectionNotImplemented: "该阶段尚未开发",
    sectionNotImplementedDesc: "该部分暂未开放。",
    listDesc: '委托书是第 5 至第 13 步共用的单据。创建后在详情页按流程逐步补充信息。',
    create: '创建委托书',
    createdWith: '已创建委托书 {modelCd}',
    deleteConfirm: '确定删除委托书 {modelCd} 吗？此操作不可恢复。',
    deleted: '已删除',
    saved: '已保存',
    searchPlaceholder: '搜索委托编号 / 款号 / 品名',

    modelCd: '委托编号',
    styleCd: '款号',
    styleNm: '品名',
    version: '版本',
    versionNo: '第 {n} 版',
    status: '状态',
    statusLabel: '状态',
    currentStep: '当前步骤',
    brand: '品牌',
    item: '生产品类',
    apparelType: '成衣类型',
    gender: '性别',
    productYear: '年度',
    season: '季节',
    salesMonth: '销售月',
    yearSeason: '年度·季节',
    yearSeasonMonth: '年度·季节·销售月',
    category: '品类分类',
    salePrice: '销售价',
    tagPrice: '吊牌价',
    receivingDueDate: '入库要求日期',
    designer: '设计师',
    sketchShort: '图稿',
    sketchLoadFailed: '图稿加载失败',
    owners: '各担当',
    progress: '进度',
    stageCount: '标记 {done}/{total}',
    stepCount: '步骤 {done}/{total}',

    pickStyle: '选择款号',
    pickStylePlaceholder: '输入款号或品名检索',
    pickStyleHint: '款号由 SAP 创建。选定后系统会自动带回品牌、年季、品类、担当、颜色与尺码。',
    pickStyleEmpty: '请先选择款号',
    existingCount: '已有 {n} 份',
    existingWarn: '该款号已有 {n} 份委托书',
    createNote: '创建后将按款式的颜色列表预建 ColorWay 行，并预建设计 Memo 与一行面料。',
    provisionalModelCd: '临时编号',
    provisionalModelCdHint:
      '款式主数据缺中分类(MCategoryCD)，委托编号里对应的两位用 -- 占位。中分类由 SP0120 从 SAP 推送，接上之后这张单需要重新编号。',
    provisionalModelCdWarn:
      '该款号没有中分类(MCategoryCD)，委托编号会是 XX--G24001 这样的临时编号，不影响后面的流程，但 SP0120 接上后需要重新编号。',
    pickFromList: '从列表选择',
    pickFair: '从订货会获取',
    fairBrand: '品牌',
    fairEvent: '订货会',
    fairHint: '先选品牌，再选订货会，系统会列出该订货会里已有订货量的所有款。',
    fairSearchPlaceholder: '按款号筛选',
    fairCount: '显示 {n} / 共 {total} 款',
    fairQty: '订货量',
    fairPick: '用这个款建单',
    fairImported: '{styleCd} 已导入本地主数据',
    fairImportOk: '已从「{event}」导入该款',
    fairImportCounts: '颜色 {colors} 个 · 尺码 {sizes} 个 · 数量 {quantities} 行 · 合计 {qty} 件',
    fairQtyNote:
      '注意：这里的数量是订货会的经销商订货量汇总，不是 SAP 的企划数量；价格是吊牌价，不是预售价。',
    fairGeneratedAt: '数据取自订货系统实时查询，生成时间 {at}',
    fairMissing:
      '订货会给不了以下信息，会先留空：{fields}。担当与入库要求日在 SAP 里有 —— 若该款号 SAP 已建档，可再用「手动输入款号」取一次补齐。',
    charges: '各担当人员',
    pickManual: '手动输入款号',
    manualStyleCd: '款号 · 单次',
    manualStyleCdPlaceholder: '输入完整款号，如 EEYSH12E01',
    styleCdSeqPlaceholder: '00',
    manualStyleHint:
      'SAP 没有「列出所有款号」的接口，本地查不到的新款号在这里直接输入，系统会现调 SP0110 取回。单次默认 00。一次调用要 30 秒以上，点击后请耐心等待，不要重复点击。',
    manualStyleEmpty: '输入款号后点「从 SAP 获取」',
    fetchFromSap: '从 SAP 获取',
    fetching: '取数中',
    fetchingHint: '正在向 SAP 取数，同步调用通常要 30 秒以上，请不要关闭弹窗。',
    syncOk: '已取回 {styleCd}，用时 {sec} 秒',
    syncCreated: '已从 SAP 取回，本地新建了该款号的主数据',
    syncUpdated: '已从 SAP 取回，本地该款号的主数据已更新',
    syncCounts: '颜色 {colors} 个 · 尺码 {sizes} 个 · 订单数量 {quantities} 行',
    syncNewTagColors: '其中 {n} 个颜色本地字典里原本没有，已按 SAP 返回的颜色名补入。',
    syncMissing:
      '以下字段 SP0110 不提供，会留空：{fields}。它们由 SP0120 从 SAP 推送过来，目前还没有接收端点。',
    colors: '颜色',
    sizes: '尺码',
    baseSize: '基准',

    basicInfo: '主信息',
    basicInfoHint: '带绿点的信息来自 SAP 款式档案，建单时自动带出，不能在这里修改',
    editableFields: '本系统录入',
    stdSize: '基准尺码',
    stdSizePlaceholder: '如 160',
    stitchDensity: '针距',
    stitchDensityPlaceholder: '如 14 针/英寸',
    remark: '备注',

    materials: '面料',
    materialsHint: '面料。使用部位、面料分类、面料代码为必填',
    materialsEmpty: '暂无面料 — 点「新增行」开始录入',
    materialsLaterNote: '幅宽与用量点「填写用量」后录入。',
    usedPart: '使用部位',
    materialGroup: '面料分类',
    materialCode: '面料代码',
    materialNm: '面料名称',
    materialMemo: '面料 Memo',
    fabricMemo: '面料备注',
    removeColorColumn: '减少列',
    removeColorColumnConfirm: '移除 {part} 列及其配色内容？',
    colorColumnInUse: '面料正在使用 {part} 配色部位，请先修改面料资料。',
    addColorColumn: '增加列',
    usageAndCost: '用量与成本',
    usageAndCostHint: '设计师录入的面料与辅料清单。用量必填；单价与币种可由面辅料采购补录。',
    usageAndCostEmpty: '还没有面料或辅料 —— 先在「面料与配色」「辅料 BOM」录入',
    usageAndCostSaved: '用量与单价已保存',
    usageMissing: '有 {n} 行还没填用量',
    kind: '种类',
    size: '尺码',
    amount: '金额',
    totalCost: '合计',
    restSizes: '其余尺码',
    fabric: '面料',
    trim: '辅料',
    fillYardage: '填写用量',
    exitYardage: '返回基本信息',
    widthRequired: '幅宽必填',
    yardageRequired: '用量必填',
    colorMatchPart: '配色部位',
    tagColor: 'Tag 颜色',
    width: '幅宽',
    yardage: '用量',
    unit: '单位',
    searchMaterial: '检索材料主数据',
    detailFields: '详细字段（别名 / 供应商 / 成分 / 后整理等）',
    weight: '克重',
    searchMaterialPlaceholder: '输入材料代码或名称',

    colorway: 'ColorWay',
    colorwayHint: '一行一个 Tag 颜色，A~G 对应七个配色部位',
    colorwayUsed: '启用 {n} 个',
    colorwayEmpty: '暂无 ColorWay 行',
    washingInfo: 'Washing',
    used: '启用',

    designMemo: '设计 Memo',
    designMemoHint: '固定 6 行，韩文与英文各一列',
    memoKo: '韩文',
    memoEn: '英文',

    qcTitle: 'QC 委托书',
    qcHint: '按轮次记录检验资料。',
    qcEmpty: '还没有 QC 记录 —— 点「新增一次 QC」开始',
    qcAddRound: '新增一次 QC',
    qcRoundName: '第 {n} 次 QC',
    qcStateDraft: '录入中',
    qcStateDone: '已完成',
    qcRemoveRound: '删除本次 QC',
    qcRemoveConfirm: '确定删除第 {n} 次 QC 吗？该次的实测记录与评论会一并删除，且不可恢复。',
    qcConfirm: '第 {n} 次完成',
    qcUnconfirm: '取消完成',
    qcLockedHint: '本次 QC 已完成，不可修改。要改请先取消完成标记',
    qcBaseInfo: '第 {n} 次 QC — 基准信息',
    qcBaseSize: '实测基准尺码',
    qcType: 'QC 类型',
    qcDictNote: 'QC 类型与 RESULT 的码值表接口文档里没有给，待后端团队提供后可在主数据里补充。下拉为空不影响其它字段录入。',
    qcAttachments: 'QC 附件',
    qcAttachmentsHint: '工厂回传资料、样品照片。',
    qcSizeCheck: '尺寸实测',
    qcSizeCheckHint: 'STANDARD SPEC 是从版型基准尺寸复制的快照。DIFF = 实测 − 标准，自动计算',
    qcSizeCheckEmpty: '还没有实测项目 —— 点「按版型基准尺寸刷新」或「新增行」开始',
    qcRefreshStd: '按版型基准尺寸刷新',
    qcComments: 'QC 评论 — 工厂 · 本社',
    qcCommentsHint: '本期由本社代录，工厂侧的意见也记在这里',
    qcCommentsEmpty: '还没有评论',
    qcAddCommentFactory: '新增工厂评论',
    qcAddCommentHq: '新增本社评论',
    qcSideFactory: '工厂',
    qcSideHq: '本社',
    qcCommentAuthorPh: '记录人',

    onlineSizeSpec: 'SIZE SPEC 实测尺寸',
    onlineSizeSpecHint: '商详页给消费者看的尺寸表。通常只放 4~6 个关键部位，不是版型基准尺寸的全量',
    onlineSizeSpecEmpty: '还没有实测项目 —— 点「按版型基准尺寸填充」或「新增行」开始',
    onlineFillFromStdSize: '按版型基准尺寸填充',
    onlineItemCd: '部位代码',
    onlineItemNm: '实测项目名',
    onlineItemNmEn: '英文名（生意书）',
    onlineCustomerLabel: '顾客表记',
    onlineMeasureMethod: '测量方法',
    onlineProductInfo: 'PRODUCT INFO 商品属性',
    onlineProductInfoHint: '电商上架用。选项来自字典，平台规则变了改字典不改代码',
    onlineWash: '洗涤方法',
    onlineFit: '版型',
    onlineElastic: '弹性',
    onlineThickness: '厚度',
    onlineLining: '里布',
    onlineSheer: '透明度',
    onlineMemo: '补充说明',
    onlineMemoPh: '商品信息补充说明',
    onlineDictEmpty: '该字典还没有数据，请先执行主数据初始化',

    uspPoints: '核心卖点',
    uspPointsHint: '给电商详情页与内部检讨用，默认 3 条，可增删',
    uspPointTitlePh: '卖点标题',
    uspPointDescPh: '展开说明',
    uspIntent: '设计意图 · 目标客群',
    uspIntentHint: '这一节不回传 SAP，是本系统自己的记录',
    uspDesignIntent: '设计意图',
    uspDesignIntentPh: '廓形、细节、选材的理由',
    uspTargetCustomer: '目标客群',
    uspTargetCustomerPh: '核心客户与穿着场景',
    uspSilhouette: '廓形',
    uspSilhouettePh: '例：半宽松',
    uspStylingTip: '搭配建议',
    uspStylingTipPh: '搭配提案',
    uspSellingCopy: '商详页文案',
    uspSellingCopyPh: '面向顾客的一句话',

    seq: '序号',
  emptyTitle: '还没有委托书',
  emptyDesc: '从订货会或已有款号开始第一个新款。',
  copiedFrom: '复制自 {style}',
  copiedFromHint: '本单内容预填自 {model}（面料、尺寸等可在此基础上修改）',
  addRow: '新增行',
  batchEntry: {
    open: '批量录入',
    title: '辅料批量录入（单价 / 用量）',
    hint: '共 {total} 个「辅料 × 尺码」，其中 {missing} 个还没填。填完关掉本窗口，回到卡片点「保存」生效。',
    onlyMissing: '只看还没填的',
    ph: '填写',
    foot: '改动直接写进卡片，未保存前都可以再改；单价与币种要成对填。',
  },
    removeRow: '删除本行',

    submit: '提交审批',
    submitted: '已提交审批',
    submitPrompt: '提交后设计内容进入审批，期间不可修改（其它角色的录入不受影响）。可填写提交说明：',
    submitCommentPlaceholder: '提交说明（选填）',
    approve: '通过',
    approved: '已通过',
    approvePrompt: '通过这份设计内容？可填写意见：',
    approveMemoPlaceholder: '审批意见（选填）',
    reject: '驳回',
    rejected: '已驳回',
    rejectPrompt: '驳回这份设计内容，请写明需要修改什么：',
    rejectMemoPlaceholder: '驳回意见（必填）',
    rejectMemoRequired: '驳回必须填写意见',
    rejectedBy: '{name} 于 {at} 驳回',
    issuesTitle: '还有 {n} 项未完成，无法提交审批',
    readyToSubmit: '信息完整，可以提交审批',
    history: '状态流转记录',
    pendingTitle: '{name} 于 {at} 提交了设计审批（第 {n} 次提交）',
    pendingTitleNoRound: '{name} 于 {at} 提交了设计审批',
    pendingComment: '提交说明：{text}',
    pendingLastReject: '上次驳回意见：{text}',
    pendingHintApprover: '请核对设计内容，在右上角「通过」或「驳回」。',
    pendingHintDesigner:
      '设计审核中。修改设计前，请先撤回提交。',
    pendingHintOther: '设计审批只锁设计师负责的内容，不影响你的录入。',
    approvalHistory: '审批记录 {n}',
    approvalRound: '第 {n} 次提交',
    approvalSubmittedBy: '{name} 于 {at} 提交',
    approvalDecidedBy: '{name} 于 {at} 裁决',
    approvalWithdrawn: '已撤回',
    approvalWithdrawnBy: '{name} 于 {at} 撤回',
    withdraw: '撤回提交',
    withdrawPrompt: '撤回后单子回到草稿，可以继续修改再重新提交。可填写撤回理由：',
    withdrawReasonPlaceholder: '撤回理由（选填）',
    withdrawn: '已撤回，单子回到草稿',

  },

  pageImport: {
    open: '导入设计稿',
    title: '导入设计稿（PDF / 图片）',
    intro: '一次放进整份 PDF 或多张图片，系统逐页拆开。第 1 页默认放进设计图稿，其余放进详细图片，可以逐页调整去向和顺序。',
    drop: '把文件拖到这里，或',
    pick: '选择文件',
    addMore: '继续添加',
    accept: '支持 PDF、PNG、JPG、WebP、GIF，单张图片不超过 {mb} MB。PowerPoint 请先另存为 PDF 再放进来。',
    pptTitle: 'PowerPoint 不拆页，请先另存为 PDF',
    pptHint: '在 PowerPoint 里点「文件 → 另存为 → PDF」，再把 PDF 放进来即可逐页拆开。下面这些 PPT 不会拆页（勾选了「存为设计原稿」的话只作存档）：{names}',
    keepOriginals: '同时把 PDF / PPT 原件存为「设计原稿」（以后做版式识别要用）',
    sourceTooLarge: '原件超过 {mb} MB，不存为设计原稿：{names}',
    uploadWithSources: '上传 {n} 页和 {m} 个原件',
    doneWithSources: '已导入 {n} 页，存了 {m} 个原件',
    unsupported: '不支持的文件类型，已跳过：{names}',
    tooLarge: '图片超过 {mb} MB，已跳过：{names}',
    renderFailed: '「{name}」无法解析，文件可能已损坏或加了密码',
    rendering: '正在拆页 {done} / {total}',
    uploading: '正在上传 {done} / {total}',
    page: '第 {n} 页',
    targetSkip: '不上传',
    moveUp: '上移',
    moveDown: '下移',
    remove: '移除',
    overfilled: '「{kind}」只能放一张，现在有多页指向它',
    willReplace: '「{kind}」已有图片，导入后会被替换',
    empty: '还没有选择文件',
    upload: '上传 {n} 页',
    done: '已导入 {n} 页',
  },
  attachKind: {
    SHIP_TAGGING: "标签缝制",
    SHIP_BOXING: "装箱",
    SHIP_FOLDING: "折叠与包装",
    SHIP_IRON: "熨烫",

    FLAT_SKETCH: '设计图稿',
    DETAIL_IMAGE: '详细图片',
    FG_IMAGE: 'FG 资料',
    DESIGN_SOURCE: '设计原稿',
    SUB_MATERIAL_IMAGE: '辅料图片',
    LABEL_SEWING: '标签缝制方法',
    SHIPPING: 'Shipping 信息',
    SHIP_FRONT: '前侧 Shipping',
    SHIP_BACK: '后侧 Shipping',
    SHIP_LEFT: '左侧 Shipping',
    SHIP_RIGHT: '右侧 Shipping',
    PATTERN_SPEC_IMAGE: '纸样尺寸图',
    QC_ATTACHMENT: 'QC 附件',
  },
  changelog: {
    attachmentUpload: '上传了「{kind}」：{file}',
    attachmentDelete: '删除了「{kind}」：{file}',
  },
  draftImport: {
    title: '识别到的设计信息',
    hint: '读自稿子的文字层，已按下面的对应关系填好。核对一遍、需要时直接改，确认后写入委托书。',
    styleMismatch: '稿子上的款号是 {draft}，与本委托书的 {sheet} 不一致 —— 请确认没有拿错文件。',
    hStyleCd: '款号',
    hSeason: '季度',
    hCollection: '系列',
    hItemName: '品名',
    hDesigner: '设计师',
    hRequestDate: '委托日',
    pickSubMaterials: '写入辅料 BOM（{n} 行）',
    pickMaterials: '写入面料（{n} 行）',
    pickColorways: '写入 ColorWay（{n} 行）',
    willReplace: '本节已有 {n} 行，会被整表替换',
    done: '已写入 {n} 行',
    noteUsedPartManual: '面料的「部位」与「位置」是稿子上的自由文字，已合并进备注 —— 使用部位是字典项，请人工选。',
    noteColorUnmatched: '配色表里的「{name}」不在本款的颜色里，这一行没有写入。',
    noteSizeUnparsed: '第 {no} 行辅料的规格「{text}」不是「数值 + 单位」，已放进备注。',
    noteQtyUnparsed: '第 {no} 行辅料的数量「{text}」不是数字，已放进备注。',
    mergeColorways: '合并进本款已有的配色行：填充 {filled} 行，其余 {kept} 行保持不变',
    logFrom: '从《{file}》识别导入',
    logPart: { materials: '面料 {n} 行', colorways: 'ColorWay {n} 行', subMaterials: '辅料 {n} 行' },

  },

  // 01 设计 · 设计稿上传（2026-10-05）。放在顶层而不是 sheet 段里：
  // sheet.designDraft 是字符串，与它同级的 key 不能挂子对象。
  designDraftUpload: {
    replacePdf: "重新上传 PDF",
    replaceImages: "重新上传图片",

    uploadPdf: '上传 PDF',
    uploadImages: '上传多张图片',
    chooseKind: '这 {n} 张图是哪一类？',
    kind: {
      sketch: '设计图稿',
      sketchHint: '款式设计图，作为委托书的核心设计稿',
      detail: '款式参考图',
      detailHint: '参考图、细节图等，不作为核心设计稿',
      fg: 'FG 图片（源文件）',
      fgHint: '成衣实物照片源文件',
    },
  },

  prefill: {
    partsUnavailable: '所选内容暂未开放，请刷新后重新选择。',
    open: '从已有委托书预填',
    afterCreate: '创建后从已有委托书预填',
    title: '从已有委托书预填',
    intro: '选一张已有的委托书（例如同版型的款），把能带的内容一次填进本单，之后再逐项修改。源委托书不会被改动。',
    searchPlaceholder: '委托编号 / 款号 / 品名 / 版型模块号',
    sameBrand: '只看 {brand} 品牌',
    module: '版型 {no}',
    noResult: '没有找到可用的委托书',
    from: '从这张委托书预填',
    otherRolesNote: '用量、尺寸等其他角色负责的内容会一并带上，预填后请各角色确认自己那一块。',
    noPriceNote: '面料与辅料的单价不带过来（价格属面辅料采购职责，源单价格多为上一款的结果），预填后由面辅料采购录入。',
    sizeMismatch: '两款尺码不同（源单 {src}，本单 {dst}）：按尺码的数据只带两边都有的尺码。',
    colorMismatch: '源单有本款没有的颜色（{list}）：这些颜色上的数据不会带过来。',
    sourceEmpty: '源单为空',
    willReplace: '本单已有 {what}，预填会替换掉',
    countRows: '{n} 行',
    countItems: '{n} 项',
    countImages: '{n} 张',
    back: '重新选择',
    submit: '预填 {n} 部分',
    done: '已从 {src} 预填 {n} 部分',
    reportTitle: '预填完成',
    reportDroppedSizes: '本款没有的尺码没带过来：{list}',
    reportDroppedColors: '本款没有的颜色没带过来：{list}',
    reportMissingFiles: '有 {n} 个附件的文件取不到，没带过来（可能只存在别人电脑上）',
    reportSkipped: '源单这几部分是空的，本单没动：{list}',
    logFrom: '从 {src} 预填：',
    part: {
      DESIGN_BASIC: '主信息',
      DESIGN_MEMO: '设计 Memo',
      DESIGN_IMAGES: '设计图稿 / 详细图片 / FG 资料',
      MATERIALS: '面料',
      COLORWAYS: 'ColorWay',
      SUB_MATERIALS: '辅料 BOM（含辅料图片）',
      MATERIAL_IMAGES: '标签缝制 / Shipping 图片',
      STD_SIZES: '基准尺寸（含版型规格图）',
      ONLINE: '在线商品信息',
      USP: 'USP·设计意图',
    },
  },

  cost: {
    title: '事前成本',
    hint: '面料、辅料按 BOM 的用量 × 单价现算，这里只录 BOM 里没有的几项。改了单价、用量保存后马上变。口径为草案，参数见「汇率与成本参数」。',
    loadFailed: '成本数据取不到，稍后刷新重试。',
    totalCost: '事前成本',
    salePrice: '预计零售价',
    costRatio: '事前成本率',
    basisLabel: '用量依据',
    basis: {
      ESTIMATE: '预估用量',
      ACTUAL: '实际用量',
      MIXED: '预估 + 实际',
    },
    inputTitle: '成本录入',
    purchaseMode: '采购模式',
    modeUnset: '未选（按自供料算）',
    mode: {
      CMT: '自供料（CMT）',
      FOB: '工厂包料（FOB）',
    },
    currency: '成本货币',
    fobPrice: 'FOB 报价',
    processingCost: '加工费',
    processingInFob: 'FOB 报价已含加工费',
    outsourcingCost: '外包工程费',
    customsCost: '通关费',
    memo: '备注',
    inputNote: '金额都是每件、按 {cur} 记。',
    breakdownTitle: '分项（每件）',
    fabricCost: '面料',
    trimCost: '辅料',
    directCost: '直接费用合计',
    overheadCost: '间接费用（{rate}）',
    referenceBomCost: '参考：BOM 面辅料成本（不计入）',
    paramsLine: '参数：{scope} · 面料损耗 {loss} · 间接费用 {overhead} · 税率 {vat} · 成本限度 {limit}',
    scopeDefault: '全公司默认',
    noLimit: '未设定',
    warnLines: '有 {price} 行缺单价、{consumption} 行缺用量，这些行没算进成本 —— 现在的成本偏低。',
    warnLinesFob: '有 {price} 行缺单价、{consumption} 行缺用量，参考成本（BOM 面辅料）偏低；FOB 款的合计不受影响。',
    warnRates: '缺汇率：{rates}。请到「汇率与成本参数」补录。',
    warnFob: 'FOB 款还没录 FOB 报价。',
    warnSaleCurrency: '售价没有币种（SAP 带回的预定销售价不带币种），成本率不计算，待确认币种。',
    warnSalePrice: '没有售价，成本率不计算。',
    warnMode: '还没选采购模式，暂按自供料计算。',
    warnNoQuantity: '还没有订单数量：只适用部分颜色 / 尺码的行，按颜色、尺码个数平均折算。',
    linesTitle: '逐行明细（{n} 行）',
    colKind: '类别',
    colItem: '代码 / 名称',
    colSize: '尺码',
    colConsumption: '用量',
    colPrice: '单价',
    colLoss: '损耗',
    colWeight: '份额',
    colAmount: '每件金额（{cur}）',
    colProblem: '问题',
    noLines: '还没有面料、辅料行',
    lineKind: {
      FABRIC: '面料',
      TRIM: '辅料',
    },
    problem: {
      NO_CONSUMPTION: '缺用量',
      NO_PRICE: '缺单价',
      NO_CURRENCY: '单价没填币种',
      NO_RATE: '缺汇率',
    },
    snapshotsTitle: '成本快照',
    noSnapshots: '还没有冻结过。冻结后的快照不随之后的修改变化，留给事后成本对比。',
    frozenAt: '冻结时间',
    frozenBy: '冻结人',
    completeLabel: '数据',
    complete: '齐全',
    incomplete: '有缺项',
    snapshotTitle: '成本快照 #{n}',
    snapParams: '面料损耗 {loss} · 间接费用 {overhead} · 税率 {vat}',
    snapRates: '当时的汇率：',
    freeze: '冻结快照',
    freezePrompt: '把当前的成本冻结成一份快照。之后改单价、用量不会影响它。可以写一句备注：',
    freezeIncompletePrompt: '当前成本有缺项（偏低），冻结下来的快照也会标「有缺项」。仍要冻结吗？可以写一句备注：',
    freezeMemoPlaceholder: '如：第一版估算、打样后更新',
    saveBeforeFreeze: '成本录入还没保存，先保存再冻结。',
    frozen: '已冻结成本快照',
    logFreeze: '冻结成本快照 #{n}：{total} {cur}',
    openHint: '查看成本明细',
    incompleteHint: '有缺单价、缺用量或缺汇率的行没算进去，成本偏低',
  },
  costConfig: {
    desc: '委托书的事前成本按这里的参数与汇率计算。口径为草案，业务答复后在这里调整即可，不用改代码。',
    paramsTitle: '成本参数',
    paramsHint: '全公司默认一组；某个品牌口径不同时单独建一组，整组覆盖默认值。',
    addBrand: '新增品牌参数',
    scope: '适用范围',
    fabricLossRate: '面料损耗率',
    overheadRate: '间接费用比例',
    vatRate: '成本率税率',
    costLimitRatio: '成本限度',
    builtinRemark: '内置默认值（还没保存过）',
    pctInvalid: '请按百分数填写数字，如 5 表示 5%',
    scopeRequired: '请填写品牌代码',
    paramsDeleteConfirm: '删除品牌 {scope} 的参数？删除后该品牌按全公司默认计算。',
    ratesTitle: '汇率',
    ratesHint: '1 单位前一种货币 = 多少后一种货币。只录一个方向，反方向自动取倒数；某天用的是生效日不晚于那天的最新一条。',
    rate: '汇率',
    effectiveDate: '生效日',
    source: '来源',
    pair: '货币对',
    inUse: '今天',
    current: '在用',
    future: '未生效',
    noRates: '还没有汇率。单价与成本货币不同时，缺汇率的行不计入成本。',
    rateDeleteConfirm: '删除 {pair}（{date} 生效）这条汇率？',
    brandPlaceholder: '品牌代码，如 EE',
    overrideNote: '成本限度留空表示不设限度（成本率不着色）。成本率超过限度标红，到限度的 90% 标黄。',
  },

  subMaterialLib: {
    emptyTitle: '辅料库还是空的',
    emptyDesc: '手工新建,或等 SAP 存量导入(过渡方案)。',
    desc: '全公司共用的辅料主数据。过渡期两种来源并存：面料采购在 SAP 里录的（查到后存一份，名称、规格、单价以 SAP 为准），和在这里新建的（要同步给 SAP 拿物料号）。',
    create: '新建辅料',
    createTitle: '新建辅料',
    searchPlaceholder: '代码 / 名称 / SAP 物料号',
    type: '种类',
    brand: '品牌',
    allBrands: '通用',
    statusLabel: '状态',
    sourceLabel: '来源',
    empty: '辅料库里还没有辅料',
    image: '图片',
    code: '代码',
    name: '名称',
    specAndPrice: '规格 · 单价',
    status: {
      ACTIVE: '启用',
      LOCKED: '锁定',
      INACTIVE: '停用',
    },
    source: {
      SAP: 'SAP 建档',
      LOCAL: '本系统建档',
      IMPORT: '导入',
    },
    sync: {
      NOT_REQUIRED: 'SAP 已有',
      PENDING: '待 SAP 建档',
      SYNCED: 'SAP 已建档',
      FAILED: 'SAP 建档失败',
    },
    provisional: '临时代码',
    provisionalHint: 'SAP 的辅料编码规则还没定，本系统先发的临时代码；SAP 建档后换成正式物料号',
    nameRequired: '请填写辅料名称',
    deleteConfirm: '删除辅料 {code}？删除后不能恢复。',
    deleted: '已删除',
    imageType: '{name} 不是图片（只收 PNG / JPG / WebP / GIF）',
    imageTooLarge: '{name} 超过 20 MB',
    usage: '被 {n} 张委托书引用（其中 {approved} 张已审批）',
    sapReadonly: 'SAP 建档的辅料：名称、种类、规格、单价以 SAP 为准，这里不能改；使用说明和图片可以补。',
    lockedHint: '已锁定：规格与单价不能改。品质变了请新建一个代码，别改旧的 —— 旧单引用的是旧品质。',
    baseTitle: '基本信息',
    codePlaceholder: '留空自动发临时代码（TMP-）',
    sapMaterialNo: 'SAP 物料号',
    sapNoPlaceholder: '已在 SAP 建档的填这里',
    brandPlaceholder: '留空 = 各品牌通用',
    unit: '单位',
    vendor: '供应商',
    specsTitle: '规格与单价',
    specsHint: '一个辅料可以有多条（不同规格不同价）；带进委托书时默认用第一条',
    gauge: '规格',
    gaugeUnit: '规格单位',
    unitPrice: '单价',
    currency: '币种',
    unitWeight: '单件重量',
    weightUnit: '重量单位',
    noSpecs: '还没有规格',
    sapGroups: 'SAP 分类（BU / 大中小分类，SAP 建档的会带）',
    memo: '使用说明',
    memoPlaceholder: '如：缝在后领中下方 2cm；洗标与主标同一供应商',
    images: '图片',
    imagesAfterSave: '先保存，再上传图片',
    addImage: '上传图片',
    lock: '锁定',
    activate: '启用',
    deactivate: '停用',
    codeSearch: '输入代码或名称查辅料库',
    filled: '已从辅料库带入：{fields}（只补了空着的格子）',
    fill: {
      type: '种类',
      contents: '名称',
      unit: '单位',
      gauge: '规格',
      price: '单价',
    },
    bomInactive: '已停用，请选择其他辅料',
    bomNotInLib: '待面辅料采购核对',
    logCodeRenamed: '辅料代码 {from} → {to}（辅料库回填 SAP 物料号时自动换的）',
    exportPending: '导出待 SAP 建档清单',
    backfill: '回填 SAP 物料号',
    backfillTitle: '回填 SAP 物料号',
    backfillHint: '把 SAP 建档结果粘进来：每行「本系统代码」「SAP 物料号」两列（可以直接从 Excel 复制两列）。临时代码（TMP-）会换成物料号，引用它的委托书辅料 BOM 跟着改，并在各单的修改履历里留记录。',
    backfillPlaceholder: 'TMP-7K2Q9D\t318EE0301\nTMP-8M3R2F\t318EE0302',
    backfillParsed: '认出 {n} 对',
    backfillBadLine: '这一行没认出两列：{line}',
    backfillSubmit: '回填 {n} 条',
    backfillResult: '回填成功 {ok} 条，失败 {fail} 条',
    backfillOutcome: '结果',
    backfillRenamed: '已换成物料号，{n} 张委托书的辅料代码跟着改了',
    backfillOk: '已记下物料号',
    backfillOne: '回填',
    sapNoBackfillPlaceholder: 'SAP 建档后填物料号',
    readinessBlocking: '有 {n} 行辅料资料待补充，请查看对应行。',
    bomCodeRequired: '请选择辅料代码',
    bomPending: '待面辅料采购确认',
    draftSummary: '对照辅料库：库里有 {ok} 行，已停用 {inactive} 行，库里没有 {notInLib} 行',
    draftFill: '按辅料库补全空格',
    draftFilled: '按辅料库补全了 {n} 行（只补空着的格子）',
    draftLibColumn: '辅料库',
    draftLib: {
      OK: '✓ 库里有',
      INACTIVE: '✗ 已停用',
      NOT_IN_LIB: '⚠ 库里没有',
      NO_CODE: '— 没认出代码',
      CHECKING: '查询中…',
    },
  },
};
